export default __webpack_public_path__ + "static/media/mail-send-yellow.e256f458.svg";